import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES } from "../constants";
import { Newspage } from "./ui/pages/news/news";

const browserLang = (navigator.language ?? "").split("-")[0];

export const routes: Routes = [
  {
    path: "",
    redirectTo: SUPPORTED_LANGUAGES.includes(browserLang) ? browserLang : DEFAULT_LANGUAGE,
    pathMatch: "full",
  },
  { path: ":lang", component: Newspage },
  { path: ":lang/:newsItemId", component: Newspage },
  { path: ":lang/:newsItemId/:newsItemTitle", component: Newspage },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class NewsRoutingModule {}
